<div *ngIf="auth.authenticated && auth?.user?.textRepliesAccess;else other_content;">

  <h2>Text Replies</h2>
  <br />
  <p *ngIf="!allStandings"><em>Loading...</em></p>

  <div *ngIf="allStandings" class="standings">
    <table class='table'>
      <thead>
        <tr>
          <th style="text-align: center">Index</th>
          <th style="text-align: center">Account Number</th>
          <th>Response</th>
          <th style="text-align: center">Phone Number</th>
          <th style="text-align: center">DateTime Received</th>
          <th style="text-align: center">Work Queue</th>
          <th style="text-align: center">Done?</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let standing of allStandings; let isOdd=odd; let i=index;">
          <tr [class.odd]="isOdd">
            <td style="text-align: center">
              {{ i + 1 }}
            </td>
            <td style="text-align: center">
              <button type="button" class="btn btn-default" (click)='popScreen(standing)'>{{ standing.accountNumber }}</button>
            </td>
            <td>
              {{ standing.response }}
            </td>
            <td style="text-align: center">
              {{ standing.phoneNumber }}
            </td>
            <td style="text-align: center">
              {{ standing.dateTimeReceived | date: 'MM/dd/yyyy hh:mm a' }}
            </td>
            <td style="text-align: center">
              {{ standing.workQueue }}
            </td>
            <td style="text-align: center">
              <button type="button" class="btn btn-success" (click)='updateDatabase(standing)'>Done</button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<ng-template #other_content>
  <div *ngIf="!auth.authenticated; else unauthorized;">
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />

    <div class="replies">
      <h1>Please <a (click)="auth.signIn()" [routerLink]="">sign in</a> to continue.</h1>
    </div>

    <br />
    <br />
    <br />
    <br />

    <div class="replies">
      <img class="logo" src="assets/CollectorAssistantToolLogoNavy.png" />
    </div>

  </div>
  <ng-template #unauthorized>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <h2 class="notAuth">You are not authorized to view this page. Please contact your manager.</h2>
  </ng-template>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/text-replies/text-replies.component.html